<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <br>
    <!-- snackbar -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <!-- begin -->
    <template>
      <v-card>
        <v-card-title>Library</v-card-title>
        <v-card-text>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Name</th>
                  <th class="text-left">PRN</th>
                  <th class="text-left">Std:Div:Roll No</th>
                  <th>Library Redirect</th>
                  <th class="text-left">Book History</th>
                  <th class="text-left">Fine</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in lib_red.l_data" :key="item.prn">
                  <td>{{ item.name }}</td>
                  <td>{{ item.prn }}</td>
                  <td>{{ item.std_div_rno }}</td>
                  <th class="text-left">
                    <form :action="lib_red.url" :key="i" name="library" target="_blank" method="post">
                      <input name="prn" type="hidden" id="udf2" :value="item.prn" />
                      <input name="hash_key" type="hidden" id="udf2" :value="item.key" />
                      <input name="tenant" type="hidden" id="tenant" :value="lib_red.tenantid" />
                      <input name="random_key" type="hidden" id="udf2" :value="item.random" />
                      <input name="uid" type="hidden" id="udf2" :value="item.uid" />
                      <input name="erp_url" type="hidden" id="udf2" :value="lib_red.erp_url" />
                      <input name="org_code" type="hidden" id="org_code" :value="lib_red.org_code" />

                      <v-btn small dense class="button" rounded type="submit" color="green">
                        <strong><v-icon>mdi-link-variant</v-icon></strong>
                      </v-btn>
                    </form>
                  </th>
                  <th class="text-left">Comming Soon</th>
                  <th class="text-left">Comning Soon</th>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card>
    </template>
  </div>
</template>
<script>
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
 
  data: () => ({
    snackbar_msg: "",
    color: "",
    // extraBreadcrumbItems: [


    // ],
    // breadcrumbClass: "breadcrumb-style1",
    snackbar: false,
    awspath: null,
    ut: null,
    ///////////////////////////////////////////////
    lib_red: null,
  }),
  methods: {
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = "Cant load profile data";
    },
    onerror(error) {
      let msg = "";
      if (error.response) {
        msg = "Something went wrong.";
      } else if (error.request) {
        msg = "Please try again.";
      } else {
        msg = "Un-expected error.";
      }
      this.showSnackbar("error", msg);
    },
    ///////////

    async call() {
      try {
        const res = await axios.post("/parentDashboard/getChildLibData");
        if (res.data.flag == "YES") {
          this.ay = res.data.ay;
          this.child_data = res.data.child_data;
          this.lib_red = res.data.lib_red;
        } else {
          this.showSnackbar("red", res.data.snackbar);
          sessionStorage.setItem("error-trace", res.data.error_trace);
        }
      } catch (err) {
        console.log("err", err);
        this.onerror(err);
      } finally {
        console.log("bye...");
      }
    },
  },
  mounted() {
    this.awspath = localStorage.getItem("awspath");
    this.ut = localStorage.getItem("EPS-ut");
    this.call();
  },
};
</script>
<style scoped></style>
